import { useIntl } from "react-intl";
import { Modal, Box, Typography, Grid, Button } from "@mui/material";
import PageHeader from "../ui/PageHeader";
import { useEffect, useState, useRef } from "react";
import { useLoading } from "../LoadingContext";
import axios from "../../api/axiosClient";
import { handleError, errorToast } from "../../services/serviceBase";
import CustomInput from "../ui/CustomInput";
import { toast } from "react-hot-toast";
import EditWarehouseDestinationsForRAList from "../ui/CreditNote/EditWarehouseDestinationsForRAList";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";

const UploadExcelModal = (props) => {
  const navigate = useNavigate();
  const intl = useIntl();

  const modalStyle = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "5px",
    width: 900,
  };

  const { setLoading } = useLoading();

  const [attachmentData, setAttachmentData] = useState([]);
  const [salePriceType, setSalePriceType] = useState("FullPrice");
  const [currencies, setCurrencies] = useState([]);
  const [currency, setCurrency] = useState({ text: "", value: null });
  const [createdReturnFileIds, setCreatedReturnFileIds] = useState([]);
  const fileRef = useRef(null);

  useEffect(() => {
    if (props.openModal) {
      getCurrencies();
    }
  }, [props.openModal]);

  const handleClose = () => {
    props.handleCloseModal();
    setAttachmentData([]);
  };

  const handleUploadExcel = () => {
    setLoading(true);
    const params = new URLSearchParams([]);
    params.append("idCompany", props.idCompany);
    params.append("senderCustomerCode", props.customerCode);
    if(props.shopCode != null){
      params.append("senderShopCode", props.shopCode);
    }
    params.append("idJDALocationDestination", props.warehouseDestination.value);
    if (props.salePriceType !== undefined && props.salePriceType !== "") {
      params.append("discriminant", props.salePriceType);
    }
    params.append("isTriangulation", props.isTriangulation);
    params.append("note", props.notes);
    params.append("deliveryNotes", props.deliveryNote);
    if (currency.value !== undefined && currency.value !== "" && currency.value != null) {
      params.append("idCurrency", currency.value);
    }
    params.append("idReconditionType", props.reconditionType.value);
    params.append("isDamaged", props.isDamaged);
    params.append("dossierType", props.dossierType.text);

    const data = new FormData();
    data.append("file", fileRef.current.files[0]);

    var url = "/creditnotereturnfiles/uploadexcel";
    if (params.size > 0) {
      url += "?" + params.toString();
    }
    axios
      .post(url, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setLoading(false);
        toast.success("Uploaded!");
        setCreatedReturnFileIds(response.data);
        let firstRF = response.data?.find(x => true);
        if(firstRF) {
          navigate(`${process.env.PUBLIC_URL}/RAPreparing/${firstRF}`);
        }
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getCurrencies = async () => {
    setLoading(true);
    axios
      .get("/creditnotereturnfiles/currencies")
      .then((response) => {
        setLoading(false);
        var items = [];
        if (response.data !== undefined) {
          response.data.map((x) => {
            items.push({
              value: x.idCurrency,
              text: x.currencyCode + " - " + x.currencyDescription,
            });
          });
        }
        setCurrencies(items);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleSalePriceTypeChange = (event) => {
    setSalePriceType(event.target.value);
  };

  return (
    <Modal open={props.openModal} onClose={handleClose}>
      <Box sx={modalStyle}>
        <PageHeader title={intl.formatMessage({ id: "RAPreparing.UploadExcel" })} />
          <Grid container id="modal-modal-description" sx={{ mt: 2 }}>
            <Grid item md={12}>
              <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Dossier type</TableCell>
                      <TableCell>Sale price type</TableCell>
                      <TableCell>Damaged</TableCell>
                      <TableCell>Recondition type</TableCell>
                      <TableCell>Warehouse destination</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow
                      //key={row.name}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell>{props.dossierType.text}</TableCell>
                      <TableCell>{props.salePriceType}</TableCell>
                      <TableCell>{props.isDamaged ? "Yes" : "No"}</TableCell>
                      <TableCell>{props.reconditionType.text}</TableCell>
                      <TableCell>{props.warehouseDestination.text}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item md={12} mt={1}>
              <CustomInput
                labelText={intl.formatMessage({ id: "General.Currency" })}
                type="autocomplete"
                value={currency}
                selectItems={currencies}
                setValue={setCurrency}
                textCol={2}
                inputCol={10}
              />
            </Grid>
            <Grid item md={12} p={0}>
              <CustomInput
                labelText={intl.formatMessage({ id: "General.File" })}
                type="file"
                valueRef={fileRef}
                sx={{ width: "100%", color: "red !important" }}
                textCol={2}
                inputCol={10}
              />
            </Grid>
            <Grid item md={2}></Grid>
            {/* <Grid item md={10}>
              <FormControl>
                <RadioGroup
                  ml={1}
                  row
                  disabled
                  value={salePriceType}
                  onChange={handleSalePriceTypeChange}
                  name="radio-buttons-group"
                >
                  <FormControlLabel
                    value="FullPrice"
                    control={<Radio />}
                    label={
                      <Typography>
                        {intl.formatMessage({ id: "General.FullPrice" })}
                      </Typography>
                    }
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value="MarkDown"
                    control={<Radio />}
                    label={
                      <Typography>
                        {intl.formatMessage({ id: "General.MarkDown" })}
                      </Typography>
                    }
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value="Damaged"
                    control={<Radio />}
                    label={
                      <Typography>
                        {intl.formatMessage({ id: "General.Damaged" })}
                      </Typography>
                    }
                    labelPlacement="end"
                  />
                </RadioGroup>
              </FormControl>
            </Grid> */}
            <Grid
              item
              md={12}
              display="flex"
              justifyContent="flex-end"
              borderBottom={4}
              pb={1}
            >
              <Button
                variant="contained"
                className="apeLigthBlueBackground"
                onClick={handleUploadExcel}
              >
                {intl.formatMessage({ id: "General.Upload" })}
              </Button>
            </Grid>
            <Grid item md={12} mt={1}>
              <div>
                <small>
                  Please note that the excel file must have the following
                  characteristics:
                  <ul>
                    <li>
                      Do not apply any specific format, just fill in the cells
                    </li>
                    <li>
                      Column A must contain 9 or 10 digit SKUs with no spaces
                    </li>
                    <li>
                      Column B must contain values greater than 0. If column
                      is completely omitted, the quantity for each row will be
                      set automatically to 1
                    </li>
                  </ul>
                </small>
              </div>
            </Grid>
          </Grid>
      </Box>
    </Modal>
  );
};

export default UploadExcelModal;
